import React from "react";
import { Gem, Users, MapPin } from "lucide-react";
import { siteData } from "../mock";

const iconMap = { Gem, Users, MapPin };

export default function Stand() {
  return (
    <section className="py-20 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-5 md:px-10">
        <div className="text-[11px] tracking-[0.32em] text-[#b88b4a] mb-5">WHAT WE STAND FOR</div>
        <h2 className="font-serif text-neutral-900 text-[38px] md:text-[56px] leading-[1.05] tracking-tight max-w-3xl">
          Principles, <span className="italic">not slogans.</span>
        </h2>

        <div className="mt-14 grid md:grid-cols-3 gap-8 md:gap-10">
          {siteData.stand.map((s) => {
            const Icon = iconMap[s.icon] || Gem;
            return (
              <div key={s.title} className="border border-[#e7e2d7] bg-jk-cream p-8 md:p-10">
                <Icon className="w-7 h-7 text-[#b88b4a] mb-7" strokeWidth={1.4} />
                <h3 className="font-serif text-neutral-900 text-[26px] md:text-[28px] leading-tight mb-4">{s.title}</h3>
                <p className="text-neutral-700 text-[15px] leading-[1.75]">{s.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
